import { useNavigate } from "react-router-dom";

import { referralPortalClient } from "@/services/referralPortalClient";

import "./referralPortal.css";

export default function ReferralPortalLandingPage() {
  const navigate = useNavigate();
  const session = referralPortalClient.getSession();

  return (
    <div className="referral-portal">
      <div className="referral-portal__shell">
        <div className="referral-portal__hero">
          <section className="referral-portal__brand">
            <div className="referral-portal__eyebrow">Linfinity Existing Client Portal</div>
            <h1>Request quotes without the email back-and-forth.</h1>
            <p>
              This PMapp entry point is the first rollout of the referral portal for existing clients.
              Sign in with your email code, upload your drawings, and track your request as it moves
              into quotation and project stages.
            </p>
            <div className="referral-portal__actions">
              <button className="referral-portal__button" onClick={() => navigate(session ? (session.isAdmin ? "/refer/dashboard" : "/refer/request-quote") : "/refer/login")}>
                {session ? (session.isAdmin ? "Open Dashboard" : "Request Quote") : "Login"}
              </button>
              <button className="referral-portal__button--ghost" onClick={() => navigate("/refer/join")}>
                Join / Request Access
              </button>
              {session ? (
                <button className="referral-portal__button--ghost" onClick={() => navigate("/refer/dashboard")}>
                  View Dashboard
                </button>
              ) : null}
            </div>
            <div className="referral-portal__feature-grid">
              <div className="referral-portal__feature">
                <strong>Existing-client access</strong>
                <span>Use a one-time email code instead of the internal staff-only PMapp login.</span>
              </div>
              <div className="referral-portal__feature">
                <strong>Drawing-first intake</strong>
                <span>Submit PDF, PNG, or JPEG drawings alongside your request details.</span>
              </div>
              <div className="referral-portal__feature">
                <strong>Duplicate screening</strong>
                <span>Address, phone, email, and client-name checks run before final submission.</span>
              </div>
              <div className="referral-portal__feature">
                <strong>Trackable request flow</strong>
                <span>See your request code, review state, quotation number, and project number in one place.</span>
              </div>
              <div className="referral-portal__feature">
                <strong>Admin oversight</strong>
                <span>Approved referral admins can monitor the whole referral program from the same portal styling.</span>
              </div>
            </div>
          </section>

          <aside className="referral-portal__card">
            <div className="referral-portal__eyebrow">Rollout 1</div>
            <h2>What this portal does now</h2>
            <p className="referral-portal__muted">
              The current rollout is intentionally narrow. It is built for known Linfinity clients who
              need a cleaner quotation request path first. Broader partner tiers and guest referrals can
              layer on top of this later.
            </p>
            <div className="referral-portal__grid">
              <div className="referral-portal__feature">
                <strong>Login</strong>
                <span>Email-code sign-in for existing client contacts.</span>
              </div>
              <div className="referral-portal__feature">
                <strong>Request quote</strong>
                <span>Project details plus mandatory drawing upload.</span>
              </div>
              <div className="referral-portal__feature">
                <strong>My requests</strong>
                <span>Review progress after submission.</span>
              </div>
              <div className="referral-portal__feature">
                <strong>Join</strong>
                <span>Submit an access request if your client email is not onboarded yet.</span>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </div>
  );
}
